import { createFileRoute } from "@tanstack/react-router";
import { VertragDetail } from "../../features/shell/VertragDetail";

export const Route = createFileRoute("/vertraege/$vertragId")({
  component: VertragDetailRoute,
});

function VertragDetailRoute() {
  const { vertragId } = Route.useParams();
  return <VertragDetail vertragId={vertragId} />;
}
